<template>
  <div class="table-search">
    <div
      class="table-search-item"
      v-for="searchItem in searchList"
      :key="searchItem.prop"
    >
      <component
        :is="'search-' + searchItem.type"
        :items="searchItem.items"
        v-model="searchForm[searchItem.prop]"
        @search="search"
        :attrs="searchItem.attrs"
      />
    </div>
    <div class="table-search-item">
      <el-button @click="search" style="height: 100%" type="primary">
        查询
      </el-button>
    </div>
    <div class="table-search-item">
      <el-button @click="clear" style="height: 100%">清空</el-button>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import SearchSelect from "@/components/prod/center/components/SearchSelect.vue";
import SearchInput from "@/components/prod/center/components/SearchInput.vue";
import SearchDate from "@/components/prod/center/components/searchDate.vue";
import { getCgSupplierList } from "@/servers/prod/center/index.js";
import { cloneDeep } from 'lodash';

export default {
  components: {
    SearchSelect,
    SearchInput,
    SearchDate,
  },
  props: {
    initialParams: Object,
  },
  data() {
    return {
      searchForm: {
        outerIds: "",
        skuOuterIds: "",
        title: "",
        privacyState: '',
        updateTime: [],
      },
      searchList: [
        {
          prop: "outerIds",
          type: "input",
          attrs: {
            placeholder: "多个款式编码，以英文逗号分割",
            label: "款式编码",
            isDialog: true,
          },
        },
        {
          prop: "skuOuterIds",
          type: "input",
          attrs: {
            placeholder: "多个商品编码，以英文逗号分割",
            label: "商品编码",
            isDialog: true,
          },
        },
        {
          prop: "title",
          type: "input",
          attrs: {
            placeholder: "商品名称",
          },
        },
        {
          prop: "updateTime", 
          type: 'date',
          attrs: {
            startPlaceholder: "上新开始日期",
            endPlaceholder: "上新结束日期",
            rangeSeparator: '至',
          },
        },
        {
          prop: "categoryId", 
          type: 'select', 
          attrs:{
            placeholder: '橱窗分类',
          }, 
          items: [
            {
              label: '全部',
              value: null,
            },
          ]
        },
        {
          prop: "privacyState", 
          type: 'select', 
          attrs:{
            placeholder: '公开/私密',
            clearable: true,
          }, 
          items: [
            {
              label: '公开',
              value: 0,
            },
            {
              label: '私密',
              value: 1,
            },
          ]
        },
      ],
      itemSupplier: {},
      loading: false,
      suppliers: [],
      page: {
        pageNo: 1,
        pages: 1,
      },
    };
  },
  directives: {
    loadMore: {
      bind(el, binding) {
        const selectDom = el.querySelector(
          ".el-select-dropdown .el-select-dropdown__wrap"
        );
        selectDom.addEventListener("scroll", function () {
          // 判断滚动到底部
          const flag = this.scrollHeight - this.scrollTop <= this.clientHeight;
          if (flag) {
            binding.value();
          }
        });
      },
    },
  },
  watch: {
    initialParams(newVal) {
      this.searchForm = {
        ...this.searchForm,
        ...newVal,
      }
    }
  },
  computed: {
    query() {
      let _query = {};
      for (const key in this.searchForm) {
        if (this.searchForm[key] !== "") {
          _query[key] = this.searchForm[key];
        }
      }
      const id = this.itemSupplier?.id || "";
      if (id) {
        _query.supplierIds = [id];
      }
      return _query;
    },
  },
  methods: {
    method_getSearchForm() {
      let result = cloneDeep(this.query);
      if (result.updateTime.length) {
        result.updateTimeBegin = result.updateTime[0];
        result.updateTimeEnd = result.updateTime[1];
      }
      if (result.outerIds) {
        result.outerIds = result.outerIds.split(",");
      }
      if (result.skuOuterIds) {
        result.skuOuterIds = result.skuOuterIds.split(",");
      }
      delete result.updateTime;
      return result;
    },
    searchSupplier() {
      this.page.pageNo = 1;
      this.suppliers = [];
      this.fetch_cgSupplierList();
    },
    // 采购供销商列表
    async fetch_cgSupplierList(queryText = "") {
      this.loading = false;
      if (this.page.pageNo > this.page.pages) return;
      const _params = {
        pageNo: this.page.pageNo,
        queryType: "name",
        queryText,
      };
      const res = await getCgSupplierList(_params);
      if (!res) return;
      this.suppliers = [...this.suppliers, ...res.list];
      const total = res.total || 1;
      const pageSize = res.page.pageSize;
      const pages =
        total % pageSize == 0 ? total / pageSize : total / pageSize + 1;
      this.page.pages = pages;
    },
    handleMore() {
      this.page.pageNo = this.page.pageNo + 1;
      this.fetch_cgSupplierList();
    },
    remoteMethod(query) {
      this.page.pageNo = 1;
      this.suppliers = [];
      if (query !== "") {
        this.loading = true;
        this.fetch_cgSupplierList(query);
      } else {
        this.fetch_cgSupplierList();
      }
    },
    search() {
      this.$emit("search");
    },
    clear(needSearch = true) {
      this.searchForm = {
        privacyState: "",
        outerIds: "",
        skuOuterIds: "",
        title: "",
        updateTime: [],
      };
      this.itemSupplier = {};
      if (needSearch) {
        this.search();
      }
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.table-search {
  display: flex;
  flex-wrap: wrap;

  &-item {
    margin-right: 8px;
    margin-bottom: 8px;
  }
}
</style>
